import React from 'react'
import LeftPanel from '../components/LeftPanel'
import RightSide from '../components/RightSide'

const Page2 = () => {

  return (
    <>
      <LeftPanel brands isCatogories />
      <RightSide quantityEditable />
    </>
  )
}

export default Page2
